import { render } from "./SingleCourse.vue?vue&type=template&id=402a0f25&scoped=true"
import script from "./SingleCourse.vue?vue&type=script&lang=js"
export * from "./SingleCourse.vue?vue&type=script&lang=js"

import "./SingleCourse.vue?vue&type=style&index=0&id=402a0f25&scoped=true&lang=css"

import exportComponent from "/Users/meganma/Documents/Web Projects/meganm38.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402a0f25"]])

export default __exports__